/**
 * Admin portal theme — InteriorIO brand blue on a light canvas, with a
 * deep-navy sidebar (see App.tsx).
 */
import { createTheme, type MantineColorsTuple } from '@mantine/core';

const brand: MantineColorsTuple = [
  '#EAF3FB',
  '#D5E6F6',
  '#A9CCED',
  '#7AB0E3',
  '#539ADB',
  '#3A8BD5',
  '#2172C0',
  '#1A64AB',
  '#135694',
  '#0A4580',
];

export const theme = createTheme({
  primaryColor: 'brand',
  primaryShade: 6,
  colors: { brand },
  defaultRadius: 'md',
  fontFamily:
    'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
  headings: { fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' },
  components: {
    Card: { defaultProps: { shadow: 'none' } },
    Table: { defaultProps: { verticalSpacing: 'sm', horizontalSpacing: 'md' } },
  },
});

/** Sidebar + canvas colours used by the app shell. */
export const shell = {
  navBg: '#0B1F3A',
  navText: '#B7C6D8',
  navTextActive: '#FFFFFF',
  navActiveBg: 'rgba(58, 139, 213, 0.22)',
  navGroup: '#6E86A3',
  canvas: '#F5F7FA',
};
